module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row row-wider"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "min-height": "150px"
    }
  }, [_c('tabs', {
    attrs: {
      "nav-style": "tabs"
    },
    model: {
      value: (_vm.activeTabIndex),
      callback: function($$v) {
        _vm.activeTabIndex = $$v
      },
      expression: "activeTabIndex"
    }
  }, [_c('tab', {
    attrs: {
      "header": "Production Record"
    }
  }, [(_vm.culturalResourceRecordingLoading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(!_vm.isSegment) ? _c('div', {
    staticClass: "sticky"
  }, [_c('ul', [(_vm.isAdmin) ? _c('li', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.toggleFormEnabled
    }
  }, [_vm._v(_vm._s(_vm.formEnabledToggle ? "Disable Edit" : "Enable Edit"))])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#overview"
    }
  }, [_vm._v("Overview")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#location"
    }
  }, [_vm._v("Location")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#nationalRegisterStatus"
    }
  }, [_vm._v("Register Status")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#investigativeHistory"
    }
  }, [_vm._v("Investigative History")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#propertyDescription"
    }
  }, [_vm._v("Property Description")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#siteSetting"
    }
  }, [_vm._v("Site Setting")])]), _vm._v(" "), (_vm.culturalResource.siteTypeId !== _vm.propertyTypeEnum.Building) ? _c('li', [_c('a', {
    attrs: {
      "href": "#siteNarrative"
    }
  }, [_vm._v("Site Narrative")])]) : _vm._e(), _vm._v(" "), (_vm.culturalResource.siteTypeId == _vm.propertyTypeEnum.Building) ? _c('li', [_c('a', {
    attrs: {
      "href": "#buildingDescHistory"
    }
  }, [_vm._v("Building Desc./History")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isSegment && _vm.isAdmin) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.toggleFormEnabled
    }
  }, [_vm._v(_vm._s(_vm.formEnabledToggle ? "Disable Edit" : "Enable Edit"))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-offset",
    attrs: {
      "id": "overview"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Overview")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.adminFormEnabled),
      expression: "!adminFormEnabled"
    }],
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Smithsonian Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\n                            " + _vm._s(_vm.culturalResource.smithsonianNumber) + "\n                            ")]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Record Type")]), _vm._v(" "), (_vm.culturalResource.isNoFormOnFile) ? _c('div', {
    staticClass: "col-md-4 text-label",
    staticStyle: {
      "color": "red"
    }
  }, [_c('b', [_vm._v("No Form on File")])]) : _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\n                            " + _vm._s(_vm.culturalResourceRecording.recordingTypeDescription) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Site Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\n                            " + _vm._s(_vm.culturalResourceRecording.siteName) + "\n                        ")]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Member of District or Linear")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "text-label"
  }, [_vm._v(_vm._s(_vm.culturalResource.grouping) + "\n                            "), _c('a', {
    staticClass: "fa fa-edit",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        _vm.goCulturalResourceGroup()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("\n                            Property Category\n                            "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "5px"
    },
    on: {
      "click": function($event) {
        _vm.$refs['secondaryCategoryModal'].open()
      }
    }
  }, [_vm._v("Secondary Categories")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\n                            " + _vm._s(_vm.culturalResourceRecording.siteTypeDescription) + "\n                            "), (_vm.culturalResource.isMonument) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('h4', [_c('span', {
    staticClass: "label label-default",
    staticStyle: {
      "color": "#FFFFFF"
    }
  }, [_vm._v("Monument")])])]) : _vm._e(), _vm._v(" "), (_vm.culturalResource.isLandmark) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('h4', [_c('span', {
    staticClass: "label label-default",
    staticStyle: {
      "color": "#FFFFFF"
    }
  }, [_vm._v("Landmark")])])]) : _vm._e(), _vm._v(" "), (_vm.culturalResource.isListed) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('h4', [_c('span', {
    staticClass: "label label-default",
    staticStyle: {
      "color": "#FFFFFF"
    }
  }, [_vm._v("Listed")])])]) : _vm._e()]), _vm._v(" "), _c('modal', {
    ref: "secondaryCategoryModal"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Secondary Property Categories")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('checkboxPanel', {
    ref: "siteTypePanel",
    attrs: {
      "readonly": true,
      "numColumns": 4,
      "lookupList": _vm.siteTypeList,
      "fieldName": 'siteTypeId',
      "name": "stCB"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "name": "buttonCancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['secondaryCategoryModal'].close()
      }
    }
  }, [_vm._v("Close")])])])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("\n                            Time Period\n                            "), _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "5px"
    },
    on: {
      "click": function($event) {
        _vm.$refs['secondaryTimePeriodModal'].open()
      }
    }
  }, [_vm._v("Secondary Time Periods")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\n                            " + _vm._s(_vm.culturalResourceRecording.timePeriodDescription) + "\n                        ")]), _vm._v(" "), _c('modal', {
    ref: "secondaryTimePeriodModal"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Secondary Time Periods")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('checkboxPanel', {
    ref: "timePeriodPanel",
    attrs: {
      "readonly": true,
      "numColumns": 4,
      "lookupList": _vm.timePeriodList,
      "fieldName": 'id',
      "name": "tpCB"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "name": "buttonCancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['secondaryTimePeriodModal'].close()
      }
    }
  }, [_vm._v("Close")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Is Confidential")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "text-label"
  }, [_vm._v(_vm._s(_vm.culturalResource.isConfidential ? "Yes" : "No"))])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Is Inactive")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "text-label"
  }, [_vm._v(_vm._s(_vm.culturalResource.isInactive ? "Yes" : "No"))])]), _vm._v(" "), (_vm.culturalResourceRecording.siteTypeId === _vm.propertyTypeEnum.District) ? _c('div', [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("District Ownership Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\n                                " + _vm._s((_vm.districtOwnershipTypeList.find(function (x) { return x.id === _vm.culturalResourceRecording.districtOwnershipTypeId; }) || {
    description: 'None'
  }).description) + "\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('landOwnership', {
    attrs: {
      "parentId": _vm.culturalResource.culturalResourceId,
      "source": "CulturalResource",
      "formDisabled": "true"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Identifiers")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 text-label"
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {}
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Owner")]), _vm._v(" "), _c('th', [_vm._v("Name")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.culturalResourceIdentifiers), function(identifier) {
    return _c('tr', {
      key: identifier.index
    }, [_c('td', [_vm._v(_vm._s(identifier.identifierTypeDescription))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(identifier.parentDescription))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(identifier.identifier))])])
  }))])])])]), _vm._v(" "), (_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [(_vm.culturalResourceRecording) ? _c('identificationForm', {
    ref: "identificationForm",
    attrs: {
      "culturalResourceRecording": _vm.culturalResourceRecording,
      "culturalResource": _vm.culturalResource,
      "productionAdminEdit": true,
      "source": "CulturalResource"
    },
    on: {
      "overviewSaved": _vm.loadData
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.culturalResource.isConfidential && _vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel panel-offset",
    attrs: {
      "id": "confidential"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Confidential Settings")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Tribal Consultation:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.culturalResource.tribalConsultationId),
      expression: "culturalResource.tribalConsultationId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.culturalResource, "tribalConsultationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("None")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Tribal Sensitive")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Traditional Cultural Property")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Confidential User Roles")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, _vm._l((_vm.roleList), function(role) {
    return _c('div', {
      key: role.roleId,
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.confidentialRoleList),
        expression: "confidentialRoleList"
      }],
      attrs: {
        "type": "checkbox",
        "id": role.roleId
      },
      domProps: {
        "value": role.roleId,
        "checked": Array.isArray(_vm.confidentialRoleList) ? _vm._i(_vm.confidentialRoleList, role.roleId) > -1 : (_vm.confidentialRoleList)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.confidentialRoleList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = role.roleId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.confidentialRoleList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.confidentialRoleList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.confidentialRoleList = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": role.roleId
      }
    }, [_vm._v(_vm._s(role.description))])])
  }))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Confidential Organizations")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Organization Name")]), _vm._v(" "), _c('th', [_vm._v("Remove")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.confidentialOrgList), function(item, index) {
    return _c('tr', {
      key: item.culturalResourceConfidentialOrgId
    }, [_c('td', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "fa fa-ban",
      staticStyle: {
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          _vm.removeOrganization(index)
        }
      }
    })])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-1 col-md-offset-3"
  }, [_c('button', {
    staticClass: "form-contol btn",
    on: {
      "click": function($event) {
        _vm.$refs['organizationModal'].open()
      }
    }
  }, [_vm._v("Add Organization")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.saveConfidentialSetting
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), _c('modal', {
    ref: "organizationModal"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Add User Organization")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['organizationModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Organization")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confidentialOrgDto.organizationId),
      expression: "confidentialOrgDto.organizationId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.confidentialOrgDto, "organizationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select An Organization")]), _vm._v(" "), _vm._l((_vm.organizationList), function(org) {
    return _c('option', {
      key: org.organizationId,
      domProps: {
        "value": org.organizationId
      }
    }, [_vm._v(_vm._s(org.description))])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "disabled": _vm.confidentialOrgDto.organizationId == null,
      "name": "buttonDone"
    },
    on: {
      "click": function($event) {
        _vm.addOrganization()
      }
    }
  }, [_vm._v("Add")])])])])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isSegment) ? _c('div', {
    staticClass: "panel panel-offset",
    attrs: {
      "id": "location"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Location")])]), _vm._v(" "), (!_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Site TRS")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 text-label"
  }, [_vm._v("\n                            " + _vm._s(_vm.siteTrsList.join(', ')) + "\n                        ")])]), _vm._v(" "), (_vm.historicalTrs.length > 0 && _vm.isAdmin) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Historical TRS")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 text-label"
  }, _vm._l((_vm.historicalTrs), function(trs) {
    return _c('tr', {
      key: trs.historicalTrsDate,
      staticStyle: {
        "background-color": "#edf0f2"
      }
    }, [_c('td', [_vm._v(_vm._s(trs.historicalTrsDate) + ":  " + _vm._s(trs.plssLocationDisplay))])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.location.isInsufficientLocationInfo) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-12 control-label text-label",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Insufficient Location Information")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Street Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 text-label"
  }, [_vm._v("\n                            " + _vm._s(_vm.location.streetAddress) + "\n                        ")]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("Town")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\n                            " + _vm._s(_vm.location.town) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Lot-Block")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 text-label"
  }, [_vm._v("\n                            " + _vm._s(_vm.location.lotBlock) + "\n                        ")]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("Parcel")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\n                            " + _vm._s(_vm.location.parcel) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Access Notes")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 text-label"
  }, [_vm._v("\n                            " + _vm._s(_vm.location.accessNotes) + "\n                        ")])])]) : _vm._e(), _vm._v(" "), (_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('locationForm', {
    attrs: {
      "crrId": _vm.crrId,
      "siteTrsList": _vm.siteTrsList,
      "productionAdminEdit": true,
      "historicalTrs": _vm.historicalTrs
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isSegment) ? _c('div', {
    staticClass: "panel panel-offset",
    attrs: {
      "id": "nationalRegisterStatus"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("National Register Status")])]), _vm._v(" "), (!_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('nationalRegisterStatus', {
    ref: "nationalRegisterStatus",
    attrs: {
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('nationalRegisterStatusForm', {
    attrs: {
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isSegment) ? _c('div', {
    staticClass: "panel panel-offset",
    attrs: {
      "name": "inventoryHistoryPanel",
      "id": "investigativeHistory"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Investigative History")])]), _vm._v(" "), (!_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('investigativeHistory', {
    ref: "investigativeHistory",
    attrs: {
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('investigativeHistoryForm', {
    attrs: {
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isSegment) ? _c('div', {
    staticClass: "panel panel-offset",
    attrs: {
      "id": "propertyDescription"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Property Description")])]), _vm._v(" "), (!_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('propertyDescription', {
    ref: "propertyDescription",
    attrs: {
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('propertyDescriptionForm', {
    attrs: {
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isSegment) ? _c('div', {
    staticClass: "panel panel-offset",
    attrs: {
      "name": "siteSettingPanel",
      "id": "siteSetting"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Site Setting")])]), _vm._v(" "), (!_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('siteSetting', {
    ref: "siteSetting",
    attrs: {
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('siteSettingForm', {
    attrs: {
      "crrId": _vm.crrId
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.culturalResourceRecording.siteTypeId !== _vm.propertyTypeEnum.Building) ? _c('div', {
    staticClass: "panel panel-offset",
    attrs: {
      "name": "siteNarrative",
      "id": "siteNarrative"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Site Narrative")])]), _vm._v(" "), (!_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-control",
    staticStyle: {
      "height": "auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.culturalResourceRecording.siteNarrative)
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveSiteNarrative($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('editor', {
    attrs: {
      "id": "editorSiteNarrative",
      "init": _vm.editor.options
    },
    model: {
      value: (_vm.culturalResourceRecording.siteNarrative),
      callback: function($$v) {
        _vm.$set(_vm.culturalResourceRecording, "siteNarrative", $$v)
      },
      expression: "culturalResourceRecording.siteNarrative"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.saveSiteNarrative
    }
  }, [_vm._v("Save")])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.culturalResourceRecording.siteTypeId == _vm.propertyTypeEnum.Building) ? _c('div', {
    staticClass: "panel panel-offset",
    attrs: {
      "name": "buildingDescHistory",
      "id": "buildingDescHistory"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Property Desc./History")])]), _vm._v(" "), (!_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Property Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-control",
    staticStyle: {
      "height": "auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.culturalResourceRecording.buildingDescription)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Property History")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-control",
    staticStyle: {
      "height": "auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.culturalResourceRecording.buildingHistory)
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [(!_vm.culturalResourceRecordingLoading) ? _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Property Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('editor', {
    attrs: {
      "id": "editorBuildingDesc",
      "init": _vm.editor.options
    },
    model: {
      value: (_vm.culturalResourceRecording.buildingDescription),
      callback: function($$v) {
        _vm.$set(_vm.culturalResourceRecording, "buildingDescription", $$v)
      },
      expression: "culturalResourceRecording.buildingDescription"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Property History")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('editor', {
    attrs: {
      "id": "editorBuildingHist",
      "init": _vm.editor.options
    },
    model: {
      value: (_vm.culturalResourceRecording.buildingHistory),
      callback: function($$v) {
        _vm.$set(_vm.culturalResourceRecording, "buildingHistory", $$v)
      },
      expression: "culturalResourceRecording.buildingHistory"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.saveSiteNarrative
    }
  }, [_vm._v("Save")])])])]) : _vm._e()]) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Eligibility"
    }
  }, [_c('siteHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.culturalResource),
      expression: "culturalResource"
    }],
    attrs: {
      "culturalResource": _vm.culturalResource,
      "siteName": _vm.culturalResourceRecording.siteName,
      "isProduction": true
    }
  }), _vm._v(" "), (_vm.isAdmin) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.toggleFormEnabled
    }
  }, [_vm._v(_vm._s(_vm.formEnabledToggle ? "Disable Edit" : "Enable Edit"))])]) : _vm._e(), _vm._v(" "), (!_vm.isSegment) ? _c('div', {
    staticClass: "panel panel-offset spacer",
    attrs: {
      "id": "eligibility"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Current Eligibility")])]), _vm._v(" "), (!_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.currentEval.eligibilityId === _vm.eligibilityEnum.Eligible && _vm.currentEval.isKeeperDetermined &&
    _vm.currentEvalShpoConcurred) ? _c('div', [_c('label', {
    staticClass: "col-md-4 control-label",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Eligible by NRHP Keeper")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("NRHP Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "form-control"
  }, [_vm._v(_vm._s(_vm.listedLandmarkMonument ? _vm.listedLandmarkMonument : (_vm.currentEvalShpoConcurred ? _vm.currentEval.eligibilityDescription : 'Unevaluated')))])])]), _vm._v(" "), (_vm.currentEvalShpoConcurred) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Source")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "form-control"
  }, [_vm._v(_vm._s(_vm.currentEval.concurredDescription))])])]), _vm._v(" "), (_vm.currentEval.eligibilityId === _vm.eligibilityEnum.Eligible) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Criteria Met")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "disabled": ""
    }
  }, [(_vm.currentEval.isEligibleA) ? _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "form-control"
  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.currentEval.isEligibleB) ? _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "form-control"
  }, [_vm._v("B")])]) : _vm._e(), _vm._v(" "), (_vm.currentEval.isEligibleC) ? _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "form-control"
  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.currentEval.isEligibleD) ? _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "form-control"
  }, [_vm._v("D")])]) : _vm._e()])]), _vm._v(" "), (_vm.currentEval.isEligibleB) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Associated Person")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "form-control"
  }, [_vm._v(_vm._s(_vm.currentEval.associatedPerson))])])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Contributing Component: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('span', {
    staticClass: "form-control"
  }, [_vm._v(_vm._s(_vm.currentEval.isContributing ? 'Contributing' : 'Not Contributing'))])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Discuss Condition and Integrity")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentEval.justification),
      expression: "currentEval.justification"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "750px",
      "color": "#555555"
    },
    attrs: {
      "readonly": "",
      "name": "justification",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.currentEval.justification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentEval, "justification", $event.target.value)
      }
    }
  })])])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('siteEligibilityForm', {
    attrs: {
      "evaluation": _vm.currentEval,
      "culturalResource": _vm.culturalResource
    },
    on: {
      "eligibilitySaved": _vm.loadData
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSegment),
      expression: "isSegment"
    }]
  }, [_c('segmentEvaluationForm', {
    ref: "segmentEval",
    attrs: {
      "crr": _vm.culturalResourceRecording.culturalResourceRecordingId,
      "segmentHead": _vm.segmentHead,
      "segHeadEval": _vm.segHeadEval,
      "culturalResourceId": _vm.culturalResourceId,
      "adminFormEnabled": _vm.adminFormEnabled
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel panel-offset spacer",
    attrs: {
      "id": "eligibilityHistory"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Eligibility History")])]), _vm._v(" "), (!_vm.adminFormEnabled) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.eligibilityHistory,
      "columns": _vm.elHistGridSpecColumns,
      "options": _vm.elHistGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "view",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [(!props.row.isProduction) ? _c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "to": {
              path: '/CulturalResourceRecording/' + props.row.culturalResourceRecordingId
            },
            "tag": "a"
          }
        }) : _c('span', [_vm._v("Migrated")])], 1)]
      }
    }])
  })], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Attachments"
    }
  }, [_c('siteHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.culturalResource),
      expression: "culturalResource"
    }],
    attrs: {
      "culturalResource": _vm.culturalResource,
      "siteName": _vm.culturalResourceRecording.siteName,
      "isProduction": true,
      "currentEval": _vm.currentEval
    }
  }), _vm._v(" "), (_vm.isAdmin) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.toggleFormEnabled
    }
  }, [_vm._v(_vm._s(_vm.formEnabledToggle ? "Disable Edit" : "Enable Edit"))])]) : _vm._e(), _vm._v(" "), _c('attachments', {
    ref: "attachments",
    attrs: {
      "formDisabled": !_vm.adminFormEnabled,
      "adminProdEdit": _vm.adminFormEnabled,
      "crrId": _vm.crrId,
      "loadOnMount": false
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Documents"
    }
  }, [_c('siteHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.culturalResource),
      expression: "culturalResource"
    }],
    attrs: {
      "culturalResource": _vm.culturalResource,
      "siteName": _vm.culturalResourceRecording.siteName,
      "isProduction": true,
      "currentEval": _vm.currentEval
    }
  }), _vm._v(" "), _c('siteDocuments', {
    ref: "siteDocuments",
    attrs: {
      "loadOnMount": false,
      "prodCrrId": _vm.crrId,
      "isShpo": _vm.isShpo
    }
  }), _vm._v(" "), _c('labResults', {
    ref: "labResults",
    attrs: {
      "loadOnMount": false,
      "culturalResourceId": _vm.culturalResourceId
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Map",
      "disabled": _vm.culturalResourceRecordingLoading
    }
  }, [_c('siteHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.culturalResource),
      expression: "culturalResource"
    }],
    attrs: {
      "culturalResource": _vm.culturalResource,
      "siteName": _vm.culturalResourceRecording.siteName,
      "isProduction": true,
      "currentEval": _vm.currentEval
    }
  }), _vm._v(" "), _c('mapx', {
    ref: "mapx",
    attrs: {
      "mediaTypeId": _vm.mediaTypeId,
      "parentId": _vm.crrId,
      "loadOnMount": false,
      "smithsonianNo": _vm.culturalResourceRecording.smithsonianNumber
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Recording History"
    }
  }, [_c('siteHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.culturalResource),
      expression: "culturalResource"
    }],
    attrs: {
      "culturalResource": _vm.culturalResource,
      "siteName": _vm.culturalResourceRecording.siteName,
      "isProduction": true,
      "currentEval": _vm.currentEval
    }
  }), _vm._v(" "), _c('culturalResourceRecordingHistory', {
    ref: "crrHistory",
    attrs: {
      "loadOnMount": false,
      "productionCrrId": _vm.crrId,
      "siteTrsList": _vm.siteTrsList,
      "smithNo": _vm.culturalResource.smithsonianNumber
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_vm._v("Site Number Request")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("View")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("Project Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Current Status")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.siteNumberRequest), function(snr) {
    return _c('tr', {
      key: snr.siteNumberRequestId,
      staticStyle: {
        "background-color": "#edf0f2"
      }
    }, [_c('td', [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('router-link', {
      staticClass: "fa fa-edit",
      staticStyle: {
        "font-size": "18px"
      },
      attrs: {
        "to": {
          path: '/SiteNumberRequest/' + snr.siteNumberRequestId
        },
        "tag": "a"
      }
    })], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(snr.projectName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(snr.workflowStatusDescription))])])
  }), _vm._v(" "), (_vm.siteNumberRequest.length == 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#edf0f2",
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                            No matching records\n                        ")])]) : _vm._e()], 2)])])], 1)], 1)], 1)]), _vm._v(" "), (_vm.isDebug) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div')]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("****** Debug ******")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4041211a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/culturalResource.vue
// module id = 926
// module chunks = 1